"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateLoanTapeTypeMap = exports.ensureNoDuplicateDependencies = exports.removeDependencies = exports.removeDependency = exports.removeArtifactsByTypes = exports.removeDependenciesByInputArtifactId = exports.insertDependency = exports.getDependency = exports.filterUserInputNeededNodesByInputType = exports.getOutputTapes = exports.getDependenciesByInputId = exports.getAllDependencyInputTapes = exports.getInputTapes = exports.getDependenciesByOutputId = exports.filterApprovalReports = exports.filterFundingRequests = exports.filterCashBalancesFeedContexts = exports.filterBusUploadToDatalakes = exports.filterReconciledBusTapes = exports.filterManualBankAccountReports = exports.filterWaitForDataLakeTables = exports.filterCashResponseTapes = exports.filterInternalRepaymentTapes = exports.filterSyntheticAssignedRepaymentTapes = exports.filterAssignedRepaymentTapes = exports.filterGeneratedRepaymentTapes = exports.filterGeneratedCashBalanceFeeds = exports.filterValleySlsIngest = exports.filterDirectInsertBorrowingBaseReports = exports.filterBorrowingBaseReports = exports.filterReceivableResponseTapePreviews = exports.filterAssignedLoanTapes = exports.filterReceivableResponseTapes = exports.filterMasterLoanTapes = exports.filterReceivableInvoiceTapes = exports.filterReceivableDocumentationVerificationReportTapes = exports.filterGeneratedLoanTapes = exports.filterGeneratedCovenantLoanTapes = exports.filterRawSupplementTapes = exports.findOptionalArtifactBySlug = exports.findArtifactBySlugAndValidateLp = exports.findTapeIndex = exports.findArtifactBySlug = exports.findArtifactById = exports.parseArtifactDocumentId = exports.hasLoanProductSlug = exports.hasCreditFacilitySlug = void 0;
const lodash = __importStar(require("lodash"));
const remeda_1 = require("remeda");
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const dbNodes = __importStar(require("./dbNodes"));
const { cloneDeep, isArray, every, isString, upperFirst } = lodash;
const hasCreditFacilitySlug = (artifacts) => {
    return (isArray(artifacts) &&
        every(artifacts, (artifact) => isString(artifact.creditFacilitySlug)));
};
exports.hasCreditFacilitySlug = hasCreditFacilitySlug;
const hasLoanProductSlug = (artifacts) => {
    return every(artifacts, (artifact) => isString(artifact.loanProductSlug));
};
exports.hasLoanProductSlug = hasLoanProductSlug;
const parseArtifactDocumentId = (dataTapes) => {
    const artifactDocumentIds = (0, remeda_1.pipe)(dataTapes, (0, remeda_1.map)(({ artifactDocumentId }) => artifactDocumentId), (0, remeda_1.uniq)());
    (0, common_1.finleyAssert)(artifactDocumentIds.length === 1, 'artifactDocumentId must be unique');
    return artifactDocumentIds[0];
};
exports.parseArtifactDocumentId = parseArtifactDocumentId;
const findArtifactById = ({ artifactId, dataTapes, }) => {
    const filterDataTapes = (0, remeda_1.filter)(dataTapes, ({ id }) => id === artifactId);
    (0, common_1.finleyAssert)(filterDataTapes.length === 1, `single [artifactId:${artifactId}] not found. [Found:${filterDataTapes.length}]`);
    return filterDataTapes[0];
};
exports.findArtifactById = findArtifactById;
const findArtifactBySlug = ({ artifactSlug, dataTapes, }) => {
    const filterDataTapes = (0, remeda_1.filter)(dataTapes, (tape) => tape.artifactSlug === artifactSlug);
    (0, common_1.finleyAssert)(filterDataTapes.length === 1, `Expected to find single artifact, but found [count:${filterDataTapes.length}] for [artifactSlug:${artifactSlug}]`);
    return filterDataTapes[0];
};
exports.findArtifactBySlug = findArtifactBySlug;
// Index of `tape` in `dataTapes`, asserting it is there.
const findTapeIndex = ({ dataTapes, tape, }) => {
    const index = dataTapes.findIndex(({ id }) => id === tape.id);
    (0, common_1.finleyAssert)(index !== -1, `Failed to find "${upperFirst(tape.type)}" in graph: [id: ${tape.id}]`);
    return index;
};
exports.findTapeIndex = findTapeIndex;
const findArtifactBySlugAndValidateLp = (inputs) => {
    const { artifactSlug, dataTapes, loanProductSlug } = inputs;
    const targetArtifact = (0, exports.findArtifactBySlug)({ dataTapes, artifactSlug });
    (0, common_1.finleyAssert)(targetArtifact.loanProductSlug === loanProductSlug, `Mismatched loan product artifact [artifactSlug:${artifactSlug}] [targetLpSlug:${loanProductSlug}] [foundLpSlug:${targetArtifact.loanProductSlug}]`);
    return targetArtifact;
};
exports.findArtifactBySlugAndValidateLp = findArtifactBySlugAndValidateLp;
const findOptionalArtifactBySlug = (params) => {
    const { artifactSlug, dataTapes } = params;
    const filterDataTapes = dataTapes.filter((tape) => tape.artifactSlug === artifactSlug);
    (0, common_1.finleyAssert)(filterDataTapes.length <= 1, `Expected to find 0 or 1 target artifact, found ${filterDataTapes.length} for [artifactSlug:${artifactSlug}]`);
    return filterDataTapes[0] ?? null;
};
exports.findOptionalArtifactBySlug = findOptionalArtifactBySlug;
// Keeps the artifacts of one node type, checking the artifact type only.
const createNodeFilter = (node) => ({ dataTapes }) => dataTapes.filter(node.hasArtifactType);
// Like createNodeFilter, but also asserts each kept artifact passes the full
// schema check; `label` completes the "[id] is not …" assertion message.
const createValidatedNodeFilter = (node, label) => ({ dataTapes }) => dataTapes.filter(node.hasArtifactType).filter((artifact) => {
    (0, common_1.finleyAssert)(node.typeGuard(artifact), `[${artifact.id}] is not ${label}`);
    return true;
});
exports.filterRawSupplementTapes = createNodeFilter(dbNodes.rawSupplementalTape);
exports.filterGeneratedCovenantLoanTapes = createNodeFilter(dbNodes.generatedCovenantLoanTape);
exports.filterGeneratedLoanTapes = createNodeFilter(dbNodes.generatedLoanTape);
exports.filterReceivableDocumentationVerificationReportTapes = createNodeFilter(dbNodes.receivableDocumentationVerificationReport);
exports.filterReceivableInvoiceTapes = createNodeFilter(dbNodes.receivableInvoice);
exports.filterMasterLoanTapes = createNodeFilter(dbNodes.masterLoanTape);
exports.filterReceivableResponseTapes = createNodeFilter(dbNodes.receivableResponseTape);
exports.filterAssignedLoanTapes = createNodeFilter(dbNodes.assignedLoanTape);
exports.filterReceivableResponseTapePreviews = createNodeFilter(dbNodes.receivableResponseTapePreview);
exports.filterBorrowingBaseReports = createNodeFilter(dbNodes.borrowingBaseReport);
exports.filterDirectInsertBorrowingBaseReports = createNodeFilter(dbNodes.directInsertBorrowingBaseReport);
exports.filterValleySlsIngest = createNodeFilter(dbNodes.valleyBankSlsIngest);
exports.filterGeneratedCashBalanceFeeds = createNodeFilter(dbNodes.generatedCashBalanceFeed);
exports.filterGeneratedRepaymentTapes = createValidatedNodeFilter(dbNodes.generatedRepaymentTape, '"GeneratedRepaymentTape"');
exports.filterAssignedRepaymentTapes = createValidatedNodeFilter({
    hasArtifactType: dbNodes.assignedRepaymentTape.hasArtifactTypeIntermediate,
    typeGuard: dbNodes.assignedRepaymentTape.typeGuardIntermediate,
}, 'intermediate "AssignedRepaymentTape"');
exports.filterSyntheticAssignedRepaymentTapes = createValidatedNodeFilter(dbNodes.assignedRepaymentTape, '"AssignedRepaymentTape"');
exports.filterInternalRepaymentTapes = createValidatedNodeFilter(dbNodes.internalRepaymentTape, '"InternalRepaymentTape"');
exports.filterCashResponseTapes = createValidatedNodeFilter(dbNodes.cashResponseTape, '"cashResponseTape"');
exports.filterWaitForDataLakeTables = createNodeFilter(dbNodes.waitForDataLakeTable);
exports.filterManualBankAccountReports = createNodeFilter(dbNodes.manualBankAccountReport);
exports.filterReconciledBusTapes = createNodeFilter(dbNodes.reconciledBusTape);
exports.filterBusUploadToDatalakes = createNodeFilter(dbNodes.busUploadToDatalake);
exports.filterCashBalancesFeedContexts = createNodeFilter(dbNodes.cashBalancesFeedContext);
exports.filterFundingRequests = createNodeFilter(dbNodes.fundingRequest);
exports.filterApprovalReports = createNodeFilter(dbNodes.fundingApprovalReport);
const getDependenciesByOutputId = ({ outputArtifactId, dataTapeDependencies, }) => {
    const dependencies = dataTapeDependencies.filter((dep) => dep.outputArtifactId === outputArtifactId);
    return dependencies;
};
exports.getDependenciesByOutputId = getDependenciesByOutputId;
const getInputTapes = ({ outputArtifactId, dbGraph, }) => {
    const { dataTapeDependencies, dataTapes } = dbGraph;
    return (0, exports.getDependenciesByOutputId)({
        outputArtifactId,
        dataTapeDependencies,
    }).map(({ inputArtifactId }) => {
        return (0, exports.findArtifactById)({
            artifactId: inputArtifactId,
            dataTapes,
        });
    });
};
exports.getInputTapes = getInputTapes;
const getAllDependencyInputTapes = ({ outputArtifactId, dbGraph, }) => {
    const inputTapes = (0, exports.getInputTapes)({ outputArtifactId, dbGraph });
    return inputTapes.reduce((acc, inputTape) => {
        acc.push(inputTape);
        const inputTapesForInputTape = (0, exports.getInputTapes)({
            outputArtifactId: inputTape.id,
            dbGraph,
        });
        if (inputTapesForInputTape.length) {
            const inputTapesForInputTapeDependencies = (0, exports.getAllDependencyInputTapes)({
                outputArtifactId: inputTape.id,
                dbGraph,
            });
            inputTapesForInputTapeDependencies.forEach((dependency) => {
                // prevent duplicate dependencies being added if graphs diverged and then remerged
                if (!acc.find(({ id }) => dependency.id === id)) {
                    acc.push(dependency);
                }
            });
        }
        return acc;
    }, []);
};
exports.getAllDependencyInputTapes = getAllDependencyInputTapes;
const getDependenciesByInputId = ({ inputArtifactId, dataTapeDependencies, }) => {
    const dependencies = dataTapeDependencies.filter((dep) => dep.inputArtifactId === inputArtifactId);
    return dependencies;
};
exports.getDependenciesByInputId = getDependenciesByInputId;
const getOutputTapes = ({ inputArtifactId, dbGraph, }) => {
    const { dataTapeDependencies, dataTapes } = dbGraph;
    return (0, exports.getDependenciesByInputId)({
        inputArtifactId,
        dataTapeDependencies,
    }).map(({ outputArtifactId }) => {
        return (0, exports.findArtifactById)({
            artifactId: outputArtifactId,
            dataTapes,
        });
    });
};
exports.getOutputTapes = getOutputTapes;
const filterUserInputNeededNodesByInputType = ({ dataTapes }, inputType) => {
    return dataTapes
        .filter(dbNodes.userInputNeeded.hasArtifactType)
        .filter((node) => node.configuration.inputType === inputType);
};
exports.filterUserInputNeededNodesByInputType = filterUserInputNeededNodesByInputType;
const getDependency = ({ outputArtifactId, inputArtifactId, dataTapeDependencies, }) => {
    const dependencies = dataTapeDependencies.filter((dep) => dep.inputArtifactId === inputArtifactId &&
        dep.outputArtifactId === outputArtifactId);
    (0, common_1.finleyAssert)(dependencies.length === 1, 'unable to get dependency');
    return dependencies[0];
};
exports.getDependency = getDependency;
const insertDependency = ({ dataTapeDependency, insertId, }) => {
    const { outputArtifactId, inputArtifactId } = dataTapeDependency;
    const outputDependency = {
        outputArtifactId,
        inputArtifactId: insertId,
    };
    const inputDependency = {
        outputArtifactId: insertId,
        inputArtifactId,
    };
    return { outputDependency, inputDependency };
};
exports.insertDependency = insertDependency;
const removeDependenciesByInputArtifactId = ({ dataTapeDependencies, inputArtifactIds, }) => {
    const inputArtifactIdSet = new Set(inputArtifactIds);
    return (0, remeda_1.filter)(dataTapeDependencies, (dep) => !inputArtifactIdSet.has(dep.inputArtifactId));
};
exports.removeDependenciesByInputArtifactId = removeDependenciesByInputArtifactId;
const removeArtifactsByTypes = ({ dataTapes, types, }) => {
    const artifactTypeSet = new Set(types);
    return (0, remeda_1.filter)(dataTapes, (tape) => !artifactTypeSet.has(tape.type));
};
exports.removeArtifactsByTypes = removeArtifactsByTypes;
const removeDependency = ({ dataTapeDependencies, dependencyToRemove, }) => {
    const res = (0, remeda_1.filter)(dataTapeDependencies, (dep) => !(dep.inputArtifactId === dependencyToRemove.inputArtifactId &&
        dep.outputArtifactId === dependencyToRemove.outputArtifactId));
    (0, common_1.finleyAssert)(dataTapeDependencies.length - res.length === 1, `unable to remove dependency [outputArtifactId:${dependencyToRemove.outputArtifactId}] [inputArtifactId:${dependencyToRemove.inputArtifactId}]`);
    return res;
};
exports.removeDependency = removeDependency;
const removeDependencies = ({ dataTapeDependencies, dependenciesToRemove: _dependenciesToRemove, }) => {
    const dependenciesToRemove = cloneDeep(_dependenciesToRemove);
    if (!dependenciesToRemove.length)
        return dataTapeDependencies;
    const dependencyToRemove = dependenciesToRemove.shift();
    (0, common_1.finleyAssert)(dependencyToRemove, 'dependencyToRemove must exist');
    const deps = (0, exports.removeDependency)({
        dataTapeDependencies,
        dependencyToRemove,
    });
    return (0, exports.removeDependencies)({
        dataTapeDependencies: deps,
        dependenciesToRemove,
    });
};
exports.removeDependencies = removeDependencies;
// asserts that there are no duplicate dependencies in the dataTapeDependencies
// the failures message includes the `artifactSlug => artifactSlug` that was duplicated
const ensureNoDuplicateDependencies = ({ functionName, dbGraph, }) => {
    const { dataTapeDependencies, dataTapes } = dbGraph;
    const dependencies = dataTapeDependencies.map(({ outputArtifactId, inputArtifactId }) => {
        const outputArtifact = (0, exports.findArtifactById)({
            artifactId: outputArtifactId,
            dataTapes,
        });
        const inputArtifact = (0, exports.findArtifactById)({
            artifactId: inputArtifactId,
            dataTapes,
        });
        (0, common_1.finleyAssert)(outputArtifact, `${functionName}: Unable to find outputArtifact for ${outputArtifactId}`);
        (0, common_1.finleyAssert)(inputArtifact, `${functionName}: Unable to find inputArtifact for ${inputArtifactId}`);
        return `${inputArtifact.artifactSlug} => ${outputArtifact.artifactSlug}`;
    });
    // ensure no duplicate dependencies
    dependencies.forEach((dependency) => {
        const count = dependencies.filter((d) => d === dependency).length;
        (0, common_1.finleyAssert)(count === 1, `${functionName}: Duplicate dependency found: ${dependency} (count: ${count})`);
    });
};
exports.ensureNoDuplicateDependencies = ensureNoDuplicateDependencies;
const generateLoanTapeTypeMap = (dataTapes) => {
    const generatedLoanTapes = (0, exports.filterGeneratedLoanTapes)({ dataTapes });
    (0, common_1.finleyAssert)((0, exports.hasLoanProductSlug)(generatedLoanTapes), 'generatedLoanTapes must have loanProductSlug');
    return (0, remeda_1.reduce)(generatedLoanTapes, (acc, tape) => {
        if (acc[tape.loanProductSlug]) {
            (0, common_1.finleyAssert)(acc[tape.loanProductSlug] === tape.configuration.loanTapeType, new common_1.error.FinleyError('loanProduct loanTapeType is configured inconsistently.'));
            return acc;
        }
        (0, common_1.finleyAssert)(finley_types_1.typeguards.loanProduct.isLoanTapeType(tape.configuration.loanTapeType), new common_1.error.FinleyError('loanTapeType must be configured on generated loan tape as valid loanTapeType.'));
        return {
            ...acc,
            [tape.loanProductSlug]: tape.configuration.loanTapeType,
        };
    }, {});
};
exports.generateLoanTapeTypeMap = generateLoanTapeTypeMap;
//# sourceMappingURL=utils.js.map